<template>
  <div>
   <p><h1>Not Found</h1></p>
    
  </div>
</template>

<script>
export default {
    name: 'NotFound',
    components:{
        
    }

};
</script>